import { MouseEvent } from 'react';

/**
 * Hook to provide common chart interaction handlers
 * Prevents default mouse interactions to make charts non-interactive
 */
export const useChartInteractions = () => {
  const preventInteraction = (e: MouseEvent) => {
    e.preventDefault();
  };

  return {
    // Style to disable text selection
    chartStyle: {
      userSelect: 'none' as const,
    },
    // Event handlers to prevent interactions
    onMouseDown: preventInteraction,
    onClick: preventInteraction,
  };
};
